import React from "react";

import { Modal } from "@shared/components";
import { useTranslate } from "@refinedev/core";

import { SectorForm } from "../SectorForm";
import { CreateSectorModalProps } from "./types";
import { useCreateSectorModal } from "./controller";

export const CreateSectorModal = React.memo(({ modalRef, onComplete }: CreateSectorModalProps) => {
  const translate = useTranslate();

  const { methods, mutateAsync, isPending } = useCreateSectorModal(modalRef, onComplete);

  return (
    <Modal
      ref={modalRef}
      title={translate("book_sector_admin.titles.create")}
      onConfirm={mutateAsync}
      methods={methods}
      isPending={isPending}
    >
      <SectorForm />
    </Modal>
  );
});
